export default "__VITE_ASSET__BOzUXZ4J__"